'use client';
import getLocal from '@/app/utils/getLocal';
import { localValueMap } from '@/utils/locals';
import { useStore } from '@/utils/useStore';
import { getIsPadWidth } from '@elem/utils/devices';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

// 两种场景可以使用 lazy 或 dynamic 1.非首屏渲染的模块（包含条件渲染）2.拆包大小并且做seo优化可以使用 ssr: true
const EFRegion: any = dynamic(() => import('@/components/UI/EFRegion'), { ssr: false });

export default function I18n() {
    const router = getLocal();
    const { locale, route, query } = router;
    const [languageRegion, setLanguageRegion] = useState('');
    const [visible, setVisible] = useState(false);
    const [destroy, setDestroy] = useState(false);
    const store = useStore();

    if (route.includes('[')) {
        Object.entries(query)?.map((ele) => {
            const key = ele[0];
            const val = ele[1];
            route?.replace(`[${key}]`, val);
        });
    }

    const gotoRegion = () => {
        store.setStore({ currentPath: router.asPath });
        router.push({ pathname: `/${locale}/region` });
    };

    const handleClick = () => {
        const isMobile = getIsPadWidth(); //是否是移动端
        if (isMobile) {
            gotoRegion();
        } else {
            setDestroy(false);
            setVisible(true);
        }
    };

    useEffect(() => {
        const curLocal = localValueMap[locale] || localValueMap['en'];
        if (Object.keys(curLocal).length !== 0) {
            const text = `${curLocal?.regionText} (${curLocal?.languageText})`;
            setLanguageRegion(text);
        }
    }, [locale]);

    return (
        <div className={css.lang_selector}>
            <div className="lang_item_current" aria-label={languageRegion} onClick={handleClick}>
                <svg className="lang-earth" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" version="1.1" p-id="2823" width="1em" height="1em">
                    <path
                        d="M480 64C214.848 64 0 278.848 0 544S214.848 1024 480 1024 960 809.152 960 544 745.152 64 480 64zM893.696 512l-126.784 0c-5.504-138.56-45.952-260.992-107.136-342.72C790.144 231.936 881.984 360.64 893.696 512zM702.4 512 512 512 512 132.736C614.848 160.128 694.336 317.312 702.4 512zM448 132.736 448 512 257.6 512C265.664 317.312 345.152 160.128 448 132.736zM300.288 169.28C239.04 251.008 198.656 373.44 193.152 512L66.304 512C78.016 360.64 169.856 231.936 300.288 169.28zM66.304 576l126.784 0c5.504 138.56 45.952 260.992 107.136 342.72C169.856 856.064 78.016 727.36 66.304 576zM257.6 576 448 576l0 379.264C345.152 927.872 265.664 770.688 257.6 576zM512 955.264 512 576l190.4 0C694.336 770.688 614.848 927.872 512 955.264zM659.712 918.72c61.248-81.728 101.632-204.16 107.136-342.72l126.784 0C881.984 727.36 790.144 856.064 659.712 918.72z"
                        p-id="2824"
                        fill="currentColor"
                    />
                </svg>
                <span className="lang_text">{languageRegion || ''}</span>
            </div>
            {!destroy && visible && <EFRegion visible={visible} onClose={() => setVisible(false)} onDestroy={() => setDestroy(true)} />}
        </div>
    );
}
